<div class="saved-addresses" *ngIf="addresses.length">
  <div class="saved-addresses-heading" i18n="@@Delivery.SavedAddresses">Saved addresses</div>
  <div
    class="saved-address"
    *ngFor="let address of addresses; trackBy: 'id' | trackBy"
    (click)="onSelectedSavedAddress(address)"
  >
    <fa-icon class="icon-left" icon="map-pin"></fa-icon>
    <span class="address">
      {{ address | shopAddress }}
    </span>
  </div>
</div>
